var map = {
	"./account.svg": 1358,
	"./add1.svg": 8803,
	"./allocationInWarehouse.svg": 8867,
	"./allocationOutWarehouse.svg": 522,
	"./applicationForm.svg": 8751,
	"./apply-record.svg": 19,
	"./apply.svg": 9283,
	"./approval.svg": 5236,
	"./approvalCheckInventory.svg": 2104,
	"./basic-data.svg": 5618,
	"./checkInventory.svg": 25,
	"./checkInventoryRecord.svg": 6566,
	"./checkInventoryTil.svg": 8080,
	"./commonOutWarehouse.svg": 8939,
	"./commonOutWarehouse1.svg": 3888,
	"./date.svg": 4705,
	"./delete.svg": 5556,
	"./delete1.svg": 605,
	"./delete2.svg": 6430,
	"./dict.svg": 2053,
	"./download1.svg": 4962,
	"./email.svg": 1903,
	"./exit-fullscreen.svg": 4153,
	"./fullscreen.svg": 6746,
	"./home.svg": 8716,
	"./in-warehouse.svg": 8106,
	"./inventory-real.svg": 6424,
	"./inventory.svg": 7011,
	"./ios-camera.svg": 2108,
	"./mechanism.svg": 6656,
	"./operation.svg": 8820,
	"./out-warehouse.svg": 477,
	"./outInWarehouseRecord.svg": 5720,
	"./password.svg": 1322,
	"./peoples.svg": 7015,
	"./permission-manage.svg": 6544,
	"./personnel-manage.svg": 4349,
	"./phone.svg": 1855,
	"./procureWarehouse.svg": 4946,
	"./product.svg": 8850,
	"./productionWarehouse.svg": 6534,
	"./refresh.svg": 6598,
	"./required.svg": 5950,
	"./retailOutWarehouse.svg": 181,
	"./returnInWarehouse.svg": 9943,
	"./returnOutWarehouse.svg": 6502,
	"./role.svg": 1345,
	"./search.svg": 5093,
	"./seearch-advanced.svg": 9905,
	"./standardInWarehouse.svg": 792,
	"./standardOutWarehouse.svg": 9203,
	"./system.svg": 9202,
	"./top-bottom-drag.svg": 8437,
	"./tree.svg": 1225,
	"./upload1.svg": 2219,
	"./user.svg": 4692,
	"./warehouse.svg": 958,
	"./warehouseCycle.svg": 7836,
	"./warehouseDateList.svg": 9886,
	"./warehouseDateRecord.svg": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;